import template from './index.html'
import { PerformanceGuaranteeController } from './controller'

export const vsName = 'machinePerformanceGuarantee'
export const vsNgType = 'directive'

machinePerformanceGuaranteeDirective.$inject = []
export function machinePerformanceGuaranteeDirective() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: PerformanceGuaranteeController,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      performanceGuarantee: '='
    }
  }
}